module.exports = __webpack_public_path__ + "static/media/ko.8852afb3.png";